import styles from "./styles.module.scss";
import { useContext, useState,useEffect } from "react";
import { useLocation } from "react-router-dom";

import { ModalComponentProps } from "./types";
import { ModalContext } from "../../../../../contexts/modal/index.context";
import { SessionContext } from "../../../../../contexts/session/index.context";
import { TableContext } from "../../../../../contexts/table/index.context";
import { DatepickerProvider } from "../../../../../contexts/datepicker/index.context";
//Components
import Directories from "../../../../directories";
//UI
import Modal from "antd/lib/modal";
//Icons

export default function ModalComponent(props: ModalComponentProps) {
  console.log("ModalComponent popconfirm-electronic-mail");
  const { setRefreshFileEditor } = useContext(ModalContext);
  const { contextTableData, setContextTableData } = useContext(TableContext);

  const [isModalOpen, setIsModalOpen] = useState(false);

  useEffect(() => {
    if (props.email) 
    setIsModalOpen(true);
    setContextTableData([]);
  console.log("ModalComponent popconfirm-electronic-mail");

    // continueProcessing(props.email);
  }, [props.email]);
  

  const handleCancel = () => {
    setIsModalOpen(false);

    if(props.setEmail)  {
      props.setEmail(null);
      sessionStorage.removeItem("electronic_mail_data");
    }
    setRefreshFileEditor(true);
    setContextTableData([]);
    // }
  };

  const { sessionData } = useContext(SessionContext);

  return (
    <>
      <Modal
          open={isModalOpen}
          footer={null}
          // okText={intl("ok")}
          // onOk={handleOk}
          onCancel={() => handleCancel()}
          className={styles["modal-employees"]}
          destroyOnClose={true}
        >
          {/* <DatepickerProvider> */}
          <Directories url="/directories/incoming-email"
                    id={sessionData.bta_documents_id}
                    allowMultiSelect= {true}
                  />
                  {/* {!isForSignature && <Tabs defaultActiveKey="1" items={items} />} */}
          {/* </DatepickerProvider> */}
        </Modal>
    </>
  );
}
